import styled from "styled-components";

export const RootContainer = styled.div`
  padding: 0 16px;
`;

export const Title = styled.div`
  padding-top: 20px;
  padding-bottom: 16px;
  padding-left: 12px;

  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  color: #283234;

  @media screen and (max-width: 425px) {
    padding-left: 6px;
  }

  @media screen and (max-width: 375px) {
    padding-left: 0;
  }
`;

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  grid-gap: 8px;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  @media screen and (max-width: 325px) {
    grid-gap: 6px;
    padding: 6px 0px;
  }
`;

export const Text = styled.div`
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  color: #565656;
  text-align: center;
`;

export const Image = styled.img.attrs({
  alt: "img",
})`
  width: 100%;
  max-width: 65px;
  border-radius: 8px;
  aspect-ratio: 1;
  object-fit: contain;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.25);

  @media screen and (max-width: 325px) {
    max-width: 55px;
  }
`;

export const SpinWrapper = styled.div`
  height: calc(100vh - 70px);
  display: flex;
  align-items: center;
  justify-content: center;
`;
